import { getApi } from "./api_instance";

export const getGraphData = async (filter = "yearly", dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: `/projects/api/dashboard/graph?filter=${filter}`,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
